import $ from "jquery"
import { isArray } from "../../support/general";
import { makeUniversalBlockKey } from "./model";

export const phpBlocks = {};
export const phpScripts = {};

/*
    id
    subScriptId
*/
  export function handleActionsLocally(actions,handleResponse) {

    var modelUpdates={};
    var actionPayloads= [];
    $.each(actions,(a,action)=>{


        var handler = eval("verb_"+action.objectType+"_"+action.verb);
        var actionResult = handler(action);
        $.each(actionResult.updates,(key,modelUpdate)=>{
            if (!modelUpdates[key]){
                modelUpdates[key]=modelUpdate;
            } else {
                var existingUpdate = modelUpdates[key];
                if (isArray(existingUpdate)){
                    modelUpdates[key] = existingUpdate.concat(modelUpdate);
                } else {
                    modelUpdates[key] = $.extend (existingUpdate,modelUpdate);
                }
            }
        })
        actionPayloads.push(actionResult.actionReturn);
        
    })

    setTimeout(()=>{
        handleResponse({
            ok : true,
            data : {
                report : {ok:true},
                modelUpdates,
                actionPayloads
            }
        });
    },500);
}





function verb_Block_fetch(action){
    var blockId = action.blockId;
    var scriptId = action.scriptId;
    var subscriptId = action.subscriptId;
    // var subScriptId = action.subScriptId;

    var blockUpdates = {};

    if (blockId) {
    
    } else if (scriptId){
        $.each(phpBlocks,(b,block)=>{
            if (block.scriptId==scriptId && (!subscriptId || block.subscriptId==subscriptId)){
                blockUpdates[makeUniversalBlockKey(scriptId,block.id)] = $.extend(true,{},block);
            }
        })
    }

    return {
        updates : {
            Block : blockUpdates
        }
        
    }
}

function verb_Block_delete(action){
    var blockIds = action.blockIds;
    var subScriptId = action.subScriptId;

     var blockValues = [];
    if (blockIds) {

    } else {
        var removeIds = [];
        $.each(phpBlocks,(b,block)=>{
            if (block.subScriptId == subScriptId){
                removeIds.push(block.id)
            }
        });

        $.each(removeIds,(r,rId)=>{
            delete phpBlocks[rId];
        })
    }

    return {
        updates : [
        ]
    }

}

function verb_Script_fetch(action){
    var scriptId = action.scriptId;
    var script = phpScripts[scriptId];
    var scriptUpdate = {};
    scriptUpdate[scriptId]=$.extend(true,{},script);
    return {
        actionReturn : {
            ownershipId : 1234,
        },
        updates : {
            'Script':scriptUpdate,
        }
    }
}

function verb_Script_update(action){

    var scriptId = action.scriptId;
    var ownershipId = action.ownershipId;
    var updates = action.updates;

    var creations = updates.creations;
    var deletions = updates.deletions;
    var edits = updates.edits;
    var changedScript = updates.script;

    if (updates.scripts) {
        throw ("verb_Script_update : property update.scripts should be update.script");
    }
    var subscriptDeletions = updates.subscriptDeletions;
    
    $.each(creations,(c,creation)=>{
        phpBlocks[creation.block.id] = $.extend(true,{},creation.block);
    })
    
    $.each(deletions,(c,deletion)=>{
        delete phpBlocks[deletion.blockId];        
    })
    
    $.each(edits,(c,edit)=>{
        var block = phpBlocks[edit.id];
        if (edit.bits['t']){
            block.text = edit.text;
        }
        if (edit.bits['m']){
            block.meta = edit.meta;
        }
        if (edit.bits['y']){
            block.type = edit.type;
        }
        if (edit.bits['n']>=0){
            block.nextBlockId = edit.nextBlockId;
        }
        
    })
    
    if (changedScript){
        phpScripts[scriptId] = $.extend(true,{},changedScript);
    }

    $.each(subscriptDeletions,(c,subscriptId)=>{
        var script = phpScripts[scriptId];
        delete script.subscripts[subscriptId];
        // delete all phpBlocks associated with the deleted subscripts 
    })

    return {
        actionReturn:{},
        updates : [
        ]
    }
}

function verb_Script_debugDump(action){
    var scriptId = action.scriptId;

    return {
        actionReturn:{
            blocks : $.extend(true,{},phpBlocks),
            script : $.extend(true,{},phpScripts[scriptId]),
        },
        updates : [
        ]
    }
}


function verb_Block_update(action){
    var blocks = action.blocks;
    
    $.each(blocks,(b,block)=>{
        blocks[block.id]=$.extend(true,{},block);
    })

    return {
        updates : [
        ]
    }
}

function verb_Block_create(action){
    var scriptId = action.scriptId;
    var blocks = action.blocks;
    var  blockValues = [];

    $.each(blocks,(b,block)=>{
        var tempId = block.id;
        var newId = (tempId<0)?phpScripts[scriptId].nextBlockId++:tempId;
        
        block.id = newId;
        
        blocks[newId]=$.extend({},block,true);

        blockValues.push($.extend(true,{},blocks[newId]))
    })

    return {
        updates : [            {
                objectType : 'Block',
                values : blockValues
            }
        ]
    }

}
